var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderManuSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44828 4.41406C4.24813 4.41406 4.89655 5.06248 4.89655 5.86234V26.1382C4.89655 26.9381 4.24813 27.5865 3.44828 27.5865C2.64841 27.5865 2 26.9381 2 26.1382V5.86234C2 5.06248 2.64842 4.41406 3.44828 4.41406Z",
    fill: "#FF0050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89648 23.2416C6.89648 25.6413 8.84172 27.5865 11.2413 27.5865H25.7241C28.1237 27.5865 30.0689 25.6413 30.0689 23.2416V8.75889C30.0689 6.35931 28.1237 4.41406 25.7241 4.41406H11.2413C8.84174 4.41406 6.89648 6.35931 6.89648 8.75889V23.2416Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderManuSelected);
export default __webpack_public_path__ + "static/media/HeaderManuSelected.bd837dd520c223c338c7f852478ecb49.svg";
export { ForwardRef as ReactComponent };